import type { DeleteIdsResponse, PaginationParams, PlainObject, SearchCondition, Timestamps } from './common';

export const DataPermission = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
} as const;
export type DataPermission = (typeof DataPermission)[keyof typeof DataPermission];

export const DataPermissionAccess = {
  OPEN: 'open',
  OWNER: 'owner',
  NOT_ALLOWED: 'not_allowed',
  OPEN_FOR_GROUPS: 'open_for_groups',
  OPEN_FOR_USERS_IDS: 'open_for_users_ids',
} as const;
export type DataPermissionAccess = (typeof DataPermissionAccess)[keyof typeof DataPermissionAccess];

export namespace ConnectyCubeData {
  export type PermissionOptions = {
    access: DataPermissionAccess | string;
    user_ids?: string[];
    user_groups?: string[];
  };
  export type Permissions = Record<DataPermission | string, PermissionOptions>;
  export type CreateRecord = PlainObject & {
    permissions?: Permissions;
  };
  export type DataRecord = Timestamps & PlainObject & {
    _id: string;
    _parent_id: string | null;
    user_id: number;
    permissions: Permissions;
  };
  // Request parameters type
  export type CreateParams = CreateRecord | CreateRecord[];
  export type ListFilter = Omit<PaginationParams, 'offset'> & {
    count?: number;
    output?: { include?: string[]; exclude?: string[] };
    near?: string;
    [field: string]: SearchCondition<unknown> | undefined;
  };
  export type ListParams = string | string[] | ListFilter | undefined;
  export type ReadParams = { permissions: 1 };
  export type UpdateOptions = PlainObject & {
    id?: string | number;
    _id?: string | number;
    inc?: Record<string, number>;
    pull?: PlainObject;
    pull_with_filter?: Record<string, PlainObject>;
    pull_all?: Record<string, unknown[]>;
    pop?: Record<string, 1 | -1>;
    push?: Record<string, unknown[]>;
    add_to_set?: Record<string, unknown[]>;
    update_by_index?: Record<string, PlainObject<number>>;
    search_criteria?: SearchCondition<unknown>;
  };
  // Response data types
  export type ListResponse = { class_name: string; items: DataRecord[] };
  export type ReadPermissionsResponse = { record_id: string; permissions: Permissions };
  export type UpdateResponse = ListResponse & {
    skip?: number;
    limit?: number;
    total_found?: number;
    not_found?: { ids: string[] };
  };
  export type DeleteResponse = DeleteIdsResponse | { total_deleted: number };
}
